// @ts-nocheck
export interface StoreToasterProps {
    timeoutLength: number;
}
export const storeToasterProps: StoreToasterProps = {
    timeoutLength: 3000, // Majestic Custom Code changed on clients request from 30000
};
